// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  max-width: 1480px;
  margin: 0 auto;
  padding: 24px clamp(16px, 2.5vw, 36px) 48px;
}

/* Header */
.header {
  text-align: left;
  margin-bottom: 18px;
}

.title {
  font-size: clamp(1.75rem, 2.6vw, 2.25rem);
  line-height: 1.2;
  font-weight: 650;
  color: var(--color-text);
  margin-bottom: 0;
}

.subtitle {
  font-size: 0.95rem;
  color: var(--color-text-muted);
  font-weight: 400;
}

/* City filter */
.city-filter {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
}

.city-btn {
  min-height: 40px;
  padding: 8px 15px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  color: var(--color-text);
  border-radius: var(--radius-control);
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

.city-btn:hover {
  background: var(--color-brand-soft);
  color: var(--color-brand-hover);
  border-color: var(--color-brand);
}

.city-btn.active {
  background: var(--color-brand);
  color: var(--color-on-brand);
  border-color: var(--color-brand);
}

/* Metrics */
.metrics-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(220px, 0.75fr) minmax(0, 1.4fr);
  gap: 12px;
  margin-bottom: 24px;
}

.metric-card {
  background: var(--color-surface);
  border-radius: var(--radius-panel);
  padding: 18px 20px;
  box-shadow: var(--shadow-panel);
  text-align: left;
  transition: border-color 0.16s ease;
  border: 1px solid var(--color-border);
}

.metric-card:hover {
  border-color: var(--color-brand);
}

.metric-number {
  font-size: 2rem;
  line-height: 1.2;
  font-weight: 650;
  color: var(--color-brand);
  margin-bottom: 5px;
}

.metric-label {
  font-size: 0.88rem;
  color: var(--color-text-muted);
  font-weight: 450;
  line-height: 1.4;
}

.metric-group {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}

.metric-group-title {
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 600;
  color: var(--color-text);
}

.metric-group-heading {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
}

.metric-group-scope {
  font-size: 0.76rem;
  line-height: 1.35;
  color: var(--color-text-muted);
  text-align: right;
}

.metric-group-items {
  display: grid;
  align-items: start;
  min-width: 0;
}

.metric-group-items--three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.metric-group-items--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.metric-group-items--four {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.metric-item {
  min-width: 0;
}

.metric-item + .metric-item {
  border-left: 1px solid var(--color-border);
  padding-left: 12px;
}

.metric-group .metric-number {
  font-size: clamp(1.25rem, 1.7vw, 1.55rem);
  line-height: 1.2;
  white-space: nowrap;
  margin-bottom: 4px;
}

.metric-group .metric-label {
  font-size: 0.78rem;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

@media (max-width: 1100px) {
  .metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .metric-group--forecast {
    grid-column: 1 / -1;
  }
}

/* Audit summary */
.audit-summary {
  margin-bottom: 24px;
}

.audit-summary-card {
  background: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  border: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.audit-summary-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-text);
}

.audit-summary-entry {
  padding: 16px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
}

.audit-summary-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
}

.audit-summary-value {
  font-size: 1.75rem;
  font-weight: 650;
  color: var(--color-brand);
}

.audit-summary-detail {
  font-size: 1rem;
  color: var(--color-text);
}

.audit-summary-stamp {
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.audit-summary-empty {
  font-size: 0.95rem;
  color: var(--color-text-muted);
}

.audit-summary-note {
  padding: 8px 10px;
  background: var(--color-surface-muted);
  border-radius: var(--radius-control);
  font-size: 0.95rem;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
}

.audit-summary-note-label {
  font-weight: 600;
  color: var(--color-text);
  white-space: nowrap;
}

.audit-summary-note > span:not(.audit-summary-note-label) {
  flex: 1 1;
  min-width: 0;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.analytics-section {
  margin: 24px 0;
  padding: 24px;
  border-radius: var(--radius-panel);
  background: var(--color-surface);
  box-shadow: var(--shadow-panel);
  border: 1px solid var(--color-border);
}

.section-title {
  font-size: 1.65rem;
  line-height: 1.25;
  font-weight: 650;
  margin-bottom: 18px;
}

.analytics-subtitle {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 12px;
}

.analytics-error {
  padding: 12px 16px;
  background: rgba(var(--color-danger-rgb), 0.08);
  border: 1px solid rgba(var(--color-danger-rgb), 0.2);
  border-radius: var(--radius-control);
  color: var(--color-danger-hover);
  margin-bottom: 15px;
}

.analytics-loading {
  padding: 12px 16px;
  background: rgba(var(--color-brand-rgb), 0.08);
  border-radius: 10px;
  color: var(--color-brand-hover);
  margin-bottom: 15px;
}

.analytics-empty {
  padding: 20px;
  text-align: center;
  color: var(--color-text-muted);
  border: 1px dashed var(--color-border);
  border-radius: var(--radius-control);
}

.attrition-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 14px;
  margin-bottom: 24px;
}

.attrition-card {
  background: var(--color-surface);
  border-radius: var(--radius-panel);
  padding: 18px;
  box-shadow: var(--shadow-panel);
  border: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.attrition-card.probability-high {
  border-color: rgba(var(--color-danger-rgb), 0.45);
  background: var(--color-surface);
}

.attrition-card.probability-medium {
  border-color: rgba(var(--color-warning-rgb), 0.35);
}

.attrition-card.probability-low {
  border-color: rgba(var(--color-success-rgb), 0.3);
}

.attrition-card-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.attrition-card-header h4 {
  font-size: 1.1rem;
  margin-right: 10px;
}

.attrition-city {
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.attrition-info-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.attrition-label {
  font-size: 0.8rem;
  color: var(--color-text-muted);
  display: block;
}

.attrition-progress {
  height: 6px;
  background: rgba(var(--color-text-rgb), 0.05);
  border-radius: 999px;
}

.attrition-progress-bar {
  height: 100%;
  background: var(--color-success);
  border-radius: 999px;
  transition: width 0.3s ease;
}

.attrition-card.probability-medium .attrition-progress-bar {
  background: var(--color-warning);
}

.attrition-card.probability-high .attrition-progress-bar {
  background: var(--color-danger);
}

.attrition-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.attrition-pip {
  font-size: 0.85rem;
  color: var(--color-danger-hover);
  background: var(--color-danger-soft);
  padding: 6px 10px;
  border-radius: 8px;
}

.calendar-section {
  margin-top: 30px;
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 14px;
}

.calendar-card {
  background: var(--color-surface);
  border-radius: var(--radius-panel);
  padding: 20px;
  box-shadow: var(--shadow-panel);
  border: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.calendar-card-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.calendar-card-month {
  font-size: 1.2rem;
  font-weight: 600;
}

.calendar-card-range {
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.calendar-metrics {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.calendar-metrics div {
  flex: 1 1;
  min-width: 120px;
}

.calendar-label {
  font-size: 0.8rem;
  color: var(--color-text-muted);
  display: block;
}

.calendar-cities {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.calendar-city-row {
  border-top: 1px solid var(--color-border);
  padding-top: 8px;
}

.calendar-city-name {
  font-weight: 600;
}

.calendar-city-values {
  font-size: 0.85rem;
  color: var(--color-text-muted);
  display: flex;
  flex-direction: column;
}

/* Action buttons */
.action-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.add-btn {
  min-height: 44px;
  padding: 10px 18px;
  background: var(--color-brand);
  color: var(--color-on-brand);
  border: none;
  border-radius: var(--radius-control);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.16s ease, box-shadow 0.16s ease;
  box-shadow: 0 1px 2px rgba(var(--color-text-rgb), 0.08);
}

.add-btn:hover {
  background: var(--color-brand-hover);
  box-shadow: 0 3px 8px rgba(var(--color-brand-rgb), 0.16);
}

.filter-btn {
  min-height: 44px;
  padding: 10px 16px;
  background: var(--color-surface);
  color: var(--color-text);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  font-size: 0.92rem;
  font-weight: 550;
  cursor: pointer;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

.filter-btn:hover {
  background: var(--color-brand-soft);
  color: var(--color-brand-hover);
  border-color: var(--color-brand);
}

.filter-btn.active {
  background: var(--color-brand);
  color: var(--color-on-brand);
  border-color: var(--color-brand);
}

/* Main content */
.main-content {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.tab-buttons {
  display: flex;
  align-self: flex-start;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
  margin-bottom: 0;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  background: var(--color-surface-muted);
}

.tab-buttons > .tab-btn {
  min-height: 40px;
  padding: 8px 14px;
  border: 1px solid transparent;
  border-radius: 7px;
  color: var(--color-text-muted);
  border-bottom-width: 1px;
  transition: background-color 0.16s ease, color 0.16s ease;
}

.tab-buttons > .tab-btn:hover {
  background: var(--color-surface);
  color: var(--color-text);
}

.tab-buttons > .tab-btn.active {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: var(--color-on-brand);
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(var(--color-text-rgb), 0.52);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.modal-content {
  background: var(--color-surface);
  border-radius: var(--radius-panel);
  padding: 30px;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: var(--shadow-overlay);
  animation: slideIn 0.3s ease;
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--color-text);
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.modal-close:hover {
  opacity: 1;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Form panel */
.form-panel {
  background: var(--color-surface);
  border-radius: var(--radius-panel);
  padding: 30px;
  box-shadow: var(--shadow-panel);
  border: 1px solid var(--color-border);
}

.form-title {
  font-size: 1.35rem;
  font-weight: 600;
  margin-bottom: 25px;
  color: var(--color-text);
}

/* Form tabs */
.form-tabs {
  display: flex;
  margin-bottom: 25px;
  border-bottom: 1px solid var(--color-border);
}

.tab-btn {
  min-height: 40px;
  padding: 8px 14px;
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  font-weight: 500;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: background-color 0.16s ease, color 0.16s ease, border-color 0.16s ease;
}

.tab-btn.active {
  border-bottom-color: var(--color-brand);
  color: var(--color-brand-hover);
}

.tab-btn:hover {
  background: var(--color-surface-muted);
}

/* Form elements */
.form-group {
  margin-bottom: 20px;
}

/* ИПВ Info Styles */
.pip-info {
  background-color: var(--color-surface-muted);
  border-left: 4px solid var(--color-brand);
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 0.9em;
  margin: 6px 0;
  box-shadow: none;
  overflow-wrap: anywhere;
}

.pip-info > div {
  min-width: 0;
  margin: 2px 0;
  line-height: 1.3;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2px 4px;
}

.pip-info > div:first-child {
  display: block;
}

.pip-info strong {
  color: var(--color-brand);
  font-size: 1.05em;
  display: block;
  max-width: 100%;
  margin-bottom: 3px;
  padding-bottom: 3px;
  border-bottom: 1px solid rgba(var(--color-text-rgb), 0.035);
  overflow-wrap: anywhere;
}

.pip-label {
  font-weight: 500;
  color: var(--color-text-muted);
  margin-right: 0;
  min-width: 0;
  display: inline-block;
}

.pip-warning {
  color: var(--color-danger);
  font-weight: 500;
  margin-left: 4px;
  font-size: 0.85em;
}

.pip-chance {
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.9em;
}

.pip-chance-high {
  background-color: var(--color-danger-soft);
  color: var(--color-danger-hover);
}

.pip-chance-medium {
  background-color: var(--color-warning-soft);
  color: var(--color-warning);
}

.pip-chance-low {
  background-color: var(--color-success-soft);
  color: var(--color-success);
}

/* Highlight for ИПВ in progress */
.pip-in-progress {
  background-color: var(--color-info-soft);
  border-left-color: var(--color-info);
}

.pip-in-progress strong {
  color: var(--color-info);
}

/* Highlight for ИПВ at risk */
.pip-at-risk {
  background-color: var(--color-danger-soft);
  border-left-color: var(--color-danger);
}

.pip-at-risk strong {
  color: var(--color-danger);
}

/* Highlight for ИПВ completed */
.pip-completed {
  background-color: var(--color-success-soft);
  border-left-color: var(--color-success);
  opacity: 0.8;
}

.pip-completed strong {
  color: var(--color-success);
  text-decoration: line-through;
}

.form-label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: var(--color-text);
}

.form-input, .form-select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  font-size: 1rem;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
  font-family: var(--font-ui);
}

.form-input:focus, .form-select:focus {
  border-color: var(--color-brand);
  box-shadow: 0 0 0 3px rgba(var(--color-brand-rgb), 0.14);
}

.submit-btn {
  min-height: 44px;
  width: 100%;
  padding: 12px 16px;
  background: var(--color-brand);
  color: var(--color-on-brand);
  border: none;
  border-radius: var(--radius-control);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.16s ease, box-shadow 0.16s ease;
  box-shadow: 0 1px 2px rgba(var(--color-text-rgb), 0.08);
}

.submit-btn:hover {
  background: var(--color-brand-hover);
  box-shadow: 0 3px 8px rgba(var(--color-brand-rgb), 0.16);
}

/* Leaders panel */
.leaders-panel {
  background: transparent;
  border: 0;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
}

/* Audit section */
.audit-section {
  margin-top: 28px;
  background: transparent;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
  border: 0;
}

.audit-section-title {
  font-size: 1.45rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--color-text);
}

.audit-section-description {
  color: var(--color-text-muted);
  margin-bottom: 25px;
}

.audit-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.audit-form-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.audit-form-grid > .form-group:nth-child(4) {
  grid-column: 1 / -1;
}

.audit-full-list,
.audit-city-journals {
  margin-top: 30px;
}

.audit-subtitle {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: var(--color-text);
}

.audit-table-wrapper {
  overflow-x: auto;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  box-shadow: none;
}

.audit-table {
  width: 100%;
  border-collapse: collapse;
}

.audit-table th,
.audit-table td {
  padding: 14px;
  text-align: left;
  border-bottom: 1px solid rgba(var(--color-border-rgb), 0.78);
}

.audit-table th {
  background: var(--color-surface-muted);
  font-weight: 600;
}

.audit-table tbody tr:nth-child(even) {
  background: rgba(var(--color-surface-muted-rgb), 0.55);
}

.audit-empty {
  padding: 20px;
  border: 1px dashed rgba(var(--color-brand-rgb), 0.22);
  border-radius: 10px;
  color: var(--color-text-muted);
}

.audit-city-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
}

.audit-city-card {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-control);
  padding: 16px;
  background: var(--color-surface);
  box-shadow: var(--shadow-panel);
}

.audit-city-card-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.audit-city-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.audit-city-list-item {
  border-left: 4px solid var(--color-brand);
  padding-left: 10px;
}

.audit-city-list-count {
  font-weight: 600;
}

.audit-city-list-date,
.audit-city-list-stamp {
  font-size: 0.9rem;
  color: var(--color-text-muted);
}

.audit-city-empty {
  color: var(--color-text-muted);
}

.audit-submit-btn {
  min-height: 44px;
  padding: 16px;
  border: none;
  border-radius: var(--radius-control);
  font-size: 1rem;
  font-weight: 600;
  color: var(--color-on-brand);
  cursor: pointer;
  background: var(--color-brand);
  transition: background-color 0.16s ease, box-shadow 0.16s ease;
  box-shadow: 0 1px 2px rgba(var(--color-text-rgb), 0.08);
}

.audit-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.audit-submit-btn:disabled:hover {
  background: var(--color-brand);
  box-shadow: 0 1px 2px rgba(var(--color-text-rgb), 0.08);
}

.audit-submit-btn:not(:disabled):hover {
  background: var(--color-brand-hover);
  box-shadow: 0 3px 8px rgba(var(--color-brand-rgb), 0.16);
}

.panel-title {
  font-size: 1.3rem;
  line-height: 1.3;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--color-text);
}

/* Data table */
.leaders-list {
  overflow-x: auto;
  background: var(--color-surface);
  border-radius: var(--radius-control);
  box-shadow: none;
  border: 1px solid var(--color-border);
}

.data-table {
  width: 100%;
  min-width: 1120px;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.data-table th {
  background: var(--color-surface-muted);
  color: var(--color-text);
  padding: 13px 12px;
  text-align: left;
  font-weight: 600;
  border-bottom: 1px solid var(--color-border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.data-table th.sortable-column {
  padding: 0;
}

.table-sort-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  padding: 12px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: inherit;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.16s ease, color 0.16s ease;
}

.table-sort-button:hover {
  background: var(--color-brand-soft);
  color: var(--color-brand-hover);
}

.data-table td {
  padding: 12px;
  border-bottom: 1px solid var(--color-border);
  transition: background-color 0.2s ease;
}

.data-table tbody tr:hover {
  background: rgba(var(--color-surface-muted-rgb), 0.8);
}

.data-table tbody tr:nth-child(even) {
  background: rgba(var(--color-surface-muted-rgb), 0.45);
}

.data-table tbody tr:nth-child(even):hover {
  background: rgba(var(--color-surface-muted-rgb), 0.9);
}

/* Highlight cells above average */
.highlight-above-average {
  background: var(--color-brand-soft) !important;
  font-weight: 600;
  color: var(--color-brand-hover);
}

/* Action buttons in table */
.data-table td:last-child {
  text-align: center;
  min-width: 100px;
}

.leaders-table th:nth-child(11),
.leaders-table td:nth-child(11) {
  width: 190px;
  min-width: 190px;
  max-width: 190px;
}

.leaders-table th:last-child,
.leaders-table td:last-child {
  width: 104px;
  min-width: 104px;
  max-width: 104px;
  text-align: center;
}

.coffee-shops-table {
  width: 100%;
  min-width: 680px;
  table-layout: fixed;
}

.coffee-shops-table th:last-child,
.coffee-shops-table td:last-child {
  width: 124px;
  min-width: 124px;
  max-width: 124px;
  text-align: center;
}

.leaders-table .action-btn,
.coffee-shops-table .action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 32px;
  padding: 0;
  margin: 0 2px;
  line-height: 1;
  vertical-align: middle;
}

.data-table .action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background-color 0.16s ease;
  margin: 0 2px;
}

.data-table .edit-btn {
  background: var(--color-brand);
  color: var(--color-on-brand);
}

.data-table .edit-btn:hover {
  background: var(--color-brand-hover);
}

.data-table .delete-btn {
  background: var(--color-danger);
  color: var(--color-on-brand);
}

.data-table .delete-btn:hover {
  background: var(--color-danger-hover);
}

/* Leader/Coffee shop cards */
.leader-card {
  background: var(--color-surface);
  border-radius: var(--radius-control);
  padding: 20px;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
  position: relative;
  border: 1px solid rgba(var(--color-border-rgb), 0.65);
  border-left: 4px solid var(--color-brand);
}

.leader-card:hover {
  box-shadow: var(--shadow-panel);
  border-color: var(--color-brand);
}

.leader-name {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--color-text);
}

.leader-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  font-size: 0.9rem;
  color: var(--color-text);
  opacity: 0.8;
}

.leader-info div {
  display: flex;
  align-items: center;
}

/* Action buttons */
.leader-actions {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  gap: 5px;
}

.action-btn {
  padding: 6px 10px;
  border: none;
  border-radius: 5px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.edit-btn {
  background: var(--color-brand);
  color: var(--color-on-brand);
}

.edit-btn:hover {
  background: var(--color-brand-hover);
}

.delete-btn {
  background: var(--color-danger);
  color: var(--color-on-brand);
}

.delete-btn:hover {
  background: var(--color-danger-hover);
}

/* Responsive design */
@media (max-width: 768px) {
  .app {
    padding: 18px 14px 36px;
  }

  .title {
    font-size: 1.75rem;
  }

  .city-filter {
    flex-direction: row;
    align-items: stretch;
    gap: 7px;
  }

  .city-btn {
    flex: 1 1 auto;
    min-height: 42px;
    padding-inline: 12px;
  }

  .metrics-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 9px;
  }

  .metric-group--forecast {
    grid-column: auto;
  }

  .metric-card {
    padding: 14px;
  }

  .metric-group .metric-number {
    font-size: 1.65rem;
  }

  .action-buttons {
    flex-direction: row;
    align-items: stretch;
    gap: 8px;
  }

  .action-buttons > button {
    flex: 1 1 160px;
  }

  .tab-buttons {
    align-self: stretch;
  }

  .tab-buttons > .tab-btn {
    flex: 1 1 140px;
  }

  .analytics-section {
    padding: 18px 14px;
  }

  .audit-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .data-table {
    font-size: 0.8rem;
  }

  .data-table th,
  .data-table td {
    padding: 8px 6px;
  }

  .data-table th {
    font-size: 0.75rem;
  }

  .modal-content {
    margin: 12px;
    padding: 22px 18px;
    width: calc(100% - 24px);
    max-height: calc(100dvh - 24px);
  }
}

@media (max-width: 420px) {
  .app {
    padding-inline: 12px;
  }

  .metrics-grid {
    gap: 8px;
  }

  .metric-card {
    padding: 12px;
  }

  .metric-group-items--four {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 14px;
  }

  .metric-group-items--four .metric-item:nth-child(3) {
    border-left: 0;
    padding-left: 0;
  }

  .metric-group-items--four .metric-item:nth-child(n + 3) {
    border-top: 1px solid var(--color-border);
    padding-top: 12px;
  }

  .metric-group .metric-number {
    font-size: 1.35rem;
  }

  .metric-group .metric-label {
    font-size: 0.76rem;
  }

  .audit-summary-content {
    gap: 12px;
  }

  .audit-summary-entry {
    padding: 12px;
  }

  .audit-form-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* ИПВ link styles */
.pip-link {
  color: var(--color-brand) !important;
  text-decoration: underline;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pip-link:hover {
  color: var(--color-brand-hover) !important;
  text-decoration: none;
}

/* Manual/Auto attrition risk styles */
.manual-value {
  color: var(--color-text) !important;
  font-weight: bold;
}

.auto-value {
  color: var(--color-text-muted) !important;
  font-weight: normal;
}

.attrition-cell span:hover {
  text-decoration: underline;
}

.data-table th:nth-child(7),
.data-table td:nth-child(7),
.data-table th:nth-child(8),
.data-table td:nth-child(8),
.data-table th:nth-child(9),
.data-table td:nth-child(9),
.data-table th:nth-child(10),
.data-table td:nth-child(10) {
  width: 60px;
  min-width: 60px;
  max-width: 90px;
  text-align: center;
  padding: 14px 6px;
}

.data-table th:nth-child(7),
.data-table th:nth-child(8),
.data-table th:nth-child(9),
.data-table th:nth-child(10) {
  font-size: 0.75rem;
}

/* Form section for risk */
.form-section-title {
  margin: 30px 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid var(--color-brand);
  color: var(--color-text);
  font-size: 1.1rem;
  font-weight: 600;
}

.form-hint {
  display: block;
  margin-top: 5px;
  color: var(--color-text-muted);
  font-size: 0.85rem;
  line-height: 1.4;
}

.pip-risk-floor-hint {
  margin: -6px 0 14px;
}

.risk-actions {
  display: flex;
  justify-content: flex-start;
  margin: 2px 0 14px;
}

.pip-clear-btn {
  background: var(--color-surface-muted);
  border: 1px solid var(--color-border);
  color: var(--color-text-muted);
  padding: 12px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  min-height: 44px;
}

.pip-clear-btn:hover:not(:disabled) {
  background: var(--color-border);
  border-color: var(--color-border);
  color: var(--color-text);
}

.pip-clear-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.risk-clear-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: auto;
  max-width: 100%;
  min-height: 40px;
  background: var(--color-brand-soft);
  border: 1px solid rgba(var(--color-brand-rgb), 0.22);
  color: var(--color-brand-hover);
  padding: 6px 14px;
  border-radius: 999px;
  cursor: pointer;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.3;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;
}

.risk-clear-btn:hover:not(:disabled) {
  background: var(--color-brand);
  border-color: var(--color-brand);
  color: var(--color-on-brand);
  box-shadow: 0 2px 6px rgba(var(--color-brand-rgb), 0.18);
}

.risk-clear-icon {
  display: inline-grid;
  place-items: center;
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba(var(--color-brand-rgb), 0.12);
  color: var(--color-brand);
  font-size: 1.2rem;
  line-height: 1;
}

.risk-clear-btn:hover:not(:disabled) .risk-clear-icon {
  background: rgba(var(--color-text-rgb), 0.12);
  color: var(--color-on-brand);
}

@media (max-width: 520px) {
  .risk-clear-btn {
    border-radius: var(--radius-control);
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kFAAkF;AACpF;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,+EAA+E;EAC/E,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kCAAkC;EAClC,gCAAgC;EAChC,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,oDAAoD;EACpD,oCAAoC;EACpC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8DAA8D;EAC9D,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;EACxB,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,kCAAkC;EAClC,aAAa;EACb,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,kFAAkF;AACpF;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,2DAA2D;EAC3D,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gCAAgC;AAChC;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,oCAAoC;EACpC,eAAe;EACf,0DAA0D;EAC1D,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,8DAA8D;EAC9D,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,aAAa;EACb,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,8BAA8B;EAC9B,8DAA8D;EAC9D,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,wDAAwD;AAC1D;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,kCAAkC;AAClC;EACE,8CAA8C;EAC9C,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;EACE,gCAAgC;EAChC,oCAAoC;EACpC,aAAa;EACb,0DAA0D;EAC1D,kBAAkB;EAClB,qDAAqD;EACrD,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;IAChD,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yCAAyC;IACzC,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;;EAQE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,oBAAoB;EACpB,2CAA2C;EAC3C,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,oDAAoD;EACpD,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yGAAyG;AAC3G;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,4BAA4B;AAC9B;;AAEA;EACE;IACE,oCAAoC;IACpC,gBAAgB;EAClB;AACF","sourcesContent":["/* Reset and base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.app {\n  max-width: 1480px;\n  margin: 0 auto;\n  padding: 24px clamp(16px, 2.5vw, 36px) 48px;\n}\n\n/* Header */\n.header {\n  text-align: left;\n  margin-bottom: 18px;\n}\n\n.title {\n  font-size: clamp(1.75rem, 2.6vw, 2.25rem);\n  line-height: 1.2;\n  font-weight: 650;\n  color: var(--color-text);\n  margin-bottom: 0;\n}\n\n.subtitle {\n  font-size: 0.95rem;\n  color: var(--color-text-muted);\n  font-weight: 400;\n}\n\n/* City filter */\n.city-filter {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.city-btn {\n  min-height: 40px;\n  padding: 8px 15px;\n  border: 1px solid var(--color-border);\n  background: var(--color-surface);\n  color: var(--color-text);\n  border-radius: var(--radius-control);\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.9rem;\n  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n}\n\n.city-btn:hover {\n  background: var(--color-brand-soft);\n  color: var(--color-brand-hover);\n  border-color: var(--color-brand);\n}\n\n.city-btn.active {\n  background: var(--color-brand);\n  color: var(--color-on-brand);\n  border-color: var(--color-brand);\n}\n\n/* Metrics */\n.metrics-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.05fr) minmax(220px, 0.75fr) minmax(0, 1.4fr);\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.metric-card {\n  background: var(--color-surface);\n  border-radius: var(--radius-panel);\n  padding: 18px 20px;\n  box-shadow: var(--shadow-panel);\n  text-align: left;\n  transition: border-color 0.16s ease;\n  border: 1px solid var(--color-border);\n}\n\n.metric-card:hover {\n  border-color: var(--color-brand);\n}\n\n.metric-number {\n  font-size: 2rem;\n  line-height: 1.2;\n  font-weight: 650;\n  color: var(--color-brand);\n  margin-bottom: 5px;\n}\n\n.metric-label {\n  font-size: 0.88rem;\n  color: var(--color-text-muted);\n  font-weight: 450;\n  line-height: 1.4;\n}\n\n.metric-group {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n}\n\n.metric-group-title {\n  font-size: 1rem;\n  line-height: 1.3;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.metric-group-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 12px;\n}\n\n.metric-group-scope {\n  font-size: 0.76rem;\n  line-height: 1.35;\n  color: var(--color-text-muted);\n  text-align: right;\n}\n\n.metric-group-items {\n  display: grid;\n  align-items: start;\n  min-width: 0;\n}\n\n.metric-group-items--three {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.metric-group-items--two {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.metric-group-items--four {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.metric-item {\n  min-width: 0;\n}\n\n.metric-item + .metric-item {\n  border-left: 1px solid var(--color-border);\n  padding-left: 12px;\n}\n\n.metric-group .metric-number {\n  font-size: clamp(1.25rem, 1.7vw, 1.55rem);\n  line-height: 1.2;\n  white-space: nowrap;\n  margin-bottom: 4px;\n}\n\n.metric-group .metric-label {\n  font-size: 0.78rem;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 1100px) {\n  .metrics-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .metric-group--forecast {\n    grid-column: 1 / -1;\n  }\n}\n\n/* Audit summary */\n.audit-summary {\n  margin-bottom: 24px;\n}\n\n.audit-summary-card {\n  background: transparent;\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n  border: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.audit-summary-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.audit-summary-entry {\n  padding: 16px;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-control);\n}\n\n.audit-summary-content {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.audit-summary-value {\n  font-size: 1.75rem;\n  font-weight: 650;\n  color: var(--color-brand);\n}\n\n.audit-summary-detail {\n  font-size: 1rem;\n  color: var(--color-text);\n}\n\n.audit-summary-stamp {\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.audit-summary-empty {\n  font-size: 0.95rem;\n  color: var(--color-text-muted);\n}\n\n.audit-summary-note {\n  padding: 8px 10px;\n  background: var(--color-surface-muted);\n  border-radius: var(--radius-control);\n  font-size: 0.95rem;\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n  max-width: 100%;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.audit-summary-note-label {\n  font-weight: 600;\n  color: var(--color-text);\n  white-space: nowrap;\n}\n\n.audit-summary-note > span:not(.audit-summary-note-label) {\n  flex: 1;\n  min-width: 0;\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n\n.analytics-section {\n  margin: 24px 0;\n  padding: 24px;\n  border-radius: var(--radius-panel);\n  background: var(--color-surface);\n  box-shadow: var(--shadow-panel);\n  border: 1px solid var(--color-border);\n}\n\n.section-title {\n  font-size: 1.65rem;\n  line-height: 1.25;\n  font-weight: 650;\n  margin-bottom: 18px;\n}\n\n.analytics-subtitle {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.analytics-error {\n  padding: 12px 16px;\n  background: rgba(var(--color-danger-rgb), 0.08);\n  border: 1px solid rgba(var(--color-danger-rgb), 0.2);\n  border-radius: var(--radius-control);\n  color: var(--color-danger-hover);\n  margin-bottom: 15px;\n}\n\n.analytics-loading {\n  padding: 12px 16px;\n  background: rgba(var(--color-brand-rgb), 0.08);\n  border-radius: 10px;\n  color: var(--color-brand-hover);\n  margin-bottom: 15px;\n}\n\n.analytics-empty {\n  padding: 20px;\n  text-align: center;\n  color: var(--color-text-muted);\n  border: 1px dashed var(--color-border);\n  border-radius: var(--radius-control);\n}\n\n.attrition-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 14px;\n  margin-bottom: 24px;\n}\n\n.attrition-card {\n  background: var(--color-surface);\n  border-radius: var(--radius-panel);\n  padding: 18px;\n  box-shadow: var(--shadow-panel);\n  border: 1px solid var(--color-border);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.attrition-card.probability-high {\n  border-color: rgba(var(--color-danger-rgb), 0.45);\n  background: var(--color-surface);\n}\n\n.attrition-card.probability-medium {\n  border-color: rgba(var(--color-warning-rgb), 0.35);\n}\n\n.attrition-card.probability-low {\n  border-color: rgba(var(--color-success-rgb), 0.3);\n}\n\n.attrition-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n\n.attrition-card-header h4 {\n  font-size: 1.1rem;\n  margin-right: 10px;\n}\n\n.attrition-city {\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.attrition-info-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.attrition-label {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  display: block;\n}\n\n.attrition-progress {\n  height: 6px;\n  background: rgba(var(--color-text-rgb), 0.05);\n  border-radius: 999px;\n}\n\n.attrition-progress-bar {\n  height: 100%;\n  background: var(--color-success);\n  border-radius: 999px;\n  transition: width 0.3s ease;\n}\n\n.attrition-card.probability-medium .attrition-progress-bar {\n  background: var(--color-warning);\n}\n\n.attrition-card.probability-high .attrition-progress-bar {\n  background: var(--color-danger);\n}\n\n.attrition-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.attrition-pip {\n  font-size: 0.85rem;\n  color: var(--color-danger-hover);\n  background: var(--color-danger-soft);\n  padding: 6px 10px;\n  border-radius: 8px;\n}\n\n.calendar-section {\n  margin-top: 30px;\n}\n\n.calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 14px;\n}\n\n.calendar-card {\n  background: var(--color-surface);\n  border-radius: var(--radius-panel);\n  padding: 20px;\n  box-shadow: var(--shadow-panel);\n  border: 1px solid var(--color-border);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.calendar-card-header {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.calendar-card-month {\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.calendar-card-range {\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.calendar-metrics {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.calendar-metrics div {\n  flex: 1;\n  min-width: 120px;\n}\n\n.calendar-label {\n  font-size: 0.8rem;\n  color: var(--color-text-muted);\n  display: block;\n}\n\n.calendar-cities {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.calendar-city-row {\n  border-top: 1px solid var(--color-border);\n  padding-top: 8px;\n}\n\n.calendar-city-name {\n  font-weight: 600;\n}\n\n.calendar-city-values {\n  font-size: 0.85rem;\n  color: var(--color-text-muted);\n  display: flex;\n  flex-direction: column;\n}\n\n/* Action buttons */\n.action-buttons {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n}\n\n.add-btn {\n  min-height: 44px;\n  padding: 10px 18px;\n  background: var(--color-brand);\n  color: var(--color-on-brand);\n  border: none;\n  border-radius: var(--radius-control);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.16s ease, box-shadow 0.16s ease;\n  box-shadow: 0 1px 2px rgba(var(--color-text-rgb), 0.08);\n}\n\n.add-btn:hover {\n  background: var(--color-brand-hover);\n  box-shadow: 0 3px 8px rgba(var(--color-brand-rgb), 0.16);\n}\n\n.filter-btn {\n  min-height: 44px;\n  padding: 10px 16px;\n  background: var(--color-surface);\n  color: var(--color-text);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-control);\n  font-size: 0.92rem;\n  font-weight: 550;\n  cursor: pointer;\n  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n}\n\n.filter-btn:hover {\n  background: var(--color-brand-soft);\n  color: var(--color-brand-hover);\n  border-color: var(--color-brand);\n}\n\n.filter-btn.active {\n  background: var(--color-brand);\n  color: var(--color-on-brand);\n  border-color: var(--color-brand);\n}\n\n/* Main content */\n.main-content {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n}\n\n.tab-buttons {\n  display: flex;\n  align-self: flex-start;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 4px;\n  margin-bottom: 0;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-control);\n  background: var(--color-surface-muted);\n}\n\n.tab-buttons > .tab-btn {\n  min-height: 40px;\n  padding: 8px 14px;\n  border: 1px solid transparent;\n  border-radius: 7px;\n  color: var(--color-text-muted);\n  border-bottom-width: 1px;\n  transition: background-color 0.16s ease, color 0.16s ease;\n}\n\n.tab-buttons > .tab-btn:hover {\n  background: var(--color-surface);\n  color: var(--color-text);\n}\n\n.tab-buttons > .tab-btn.active {\n  background: var(--color-brand);\n  border-color: var(--color-brand);\n  color: var(--color-on-brand);\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(var(--color-text-rgb), 0.52);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n.modal-content {\n  background: var(--color-surface);\n  border-radius: var(--radius-panel);\n  padding: 30px;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: var(--shadow-overlay);\n  animation: slideIn 0.3s ease;\n}\n\n.modal-close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: var(--color-text);\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n.modal-close:hover {\n  opacity: 1;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Form panel */\n.form-panel {\n  background: var(--color-surface);\n  border-radius: var(--radius-panel);\n  padding: 30px;\n  box-shadow: var(--shadow-panel);\n  border: 1px solid var(--color-border);\n}\n\n.form-title {\n  font-size: 1.35rem;\n  font-weight: 600;\n  margin-bottom: 25px;\n  color: var(--color-text);\n}\n\n/* Form tabs */\n.form-tabs {\n  display: flex;\n  margin-bottom: 25px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.tab-btn {\n  min-height: 40px;\n  padding: 8px 14px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-weight: 500;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: background-color 0.16s ease, color 0.16s ease, border-color 0.16s ease;\n}\n\n.tab-btn.active {\n  border-bottom-color: var(--color-brand);\n  color: var(--color-brand-hover);\n}\n\n.tab-btn:hover {\n  background: var(--color-surface-muted);\n}\n\n/* Form elements */\n.form-group {\n  margin-bottom: 20px;\n}\n\n/* ИПВ Info Styles */\n.pip-info {\n  background-color: var(--color-surface-muted);\n  border-left: 4px solid var(--color-brand);\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 0.9em;\n  margin: 6px 0;\n  box-shadow: none;\n  overflow-wrap: anywhere;\n}\n\n.pip-info > div {\n  min-width: 0;\n  margin: 2px 0;\n  line-height: 1.3;\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 2px 4px;\n}\n\n.pip-info > div:first-child {\n  display: block;\n}\n\n.pip-info strong {\n  color: var(--color-brand);\n  font-size: 1.05em;\n  display: block;\n  max-width: 100%;\n  margin-bottom: 3px;\n  padding-bottom: 3px;\n  border-bottom: 1px solid rgba(var(--color-text-rgb), 0.035);\n  overflow-wrap: anywhere;\n}\n\n.pip-label {\n  font-weight: 500;\n  color: var(--color-text-muted);\n  margin-right: 0;\n  min-width: 0;\n  display: inline-block;\n}\n\n.pip-warning {\n  color: var(--color-danger);\n  font-weight: 500;\n  margin-left: 4px;\n  font-size: 0.85em;\n}\n\n.pip-chance {\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 0.9em;\n}\n\n.pip-chance-high {\n  background-color: var(--color-danger-soft);\n  color: var(--color-danger-hover);\n}\n\n.pip-chance-medium {\n  background-color: var(--color-warning-soft);\n  color: var(--color-warning);\n}\n\n.pip-chance-low {\n  background-color: var(--color-success-soft);\n  color: var(--color-success);\n}\n\n/* Highlight for ИПВ in progress */\n.pip-in-progress {\n  background-color: var(--color-info-soft);\n  border-left-color: var(--color-info);\n}\n\n.pip-in-progress strong {\n  color: var(--color-info);\n}\n\n/* Highlight for ИПВ at risk */\n.pip-at-risk {\n  background-color: var(--color-danger-soft);\n  border-left-color: var(--color-danger);\n}\n\n.pip-at-risk strong {\n  color: var(--color-danger);\n}\n\n/* Highlight for ИПВ completed */\n.pip-completed {\n  background-color: var(--color-success-soft);\n  border-left-color: var(--color-success);\n  opacity: 0.8;\n}\n\n.pip-completed strong {\n  color: var(--color-success);\n  text-decoration: line-through;\n}\n\n.form-label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: var(--color-text);\n}\n\n.form-input, .form-select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-control);\n  font-size: 1rem;\n  transition: border-color 0.16s ease, box-shadow 0.16s ease;\n  font-family: var(--font-ui);\n}\n\n.form-input:focus, .form-select:focus {\n  border-color: var(--color-brand);\n  box-shadow: 0 0 0 3px rgba(var(--color-brand-rgb), 0.14);\n}\n\n.submit-btn {\n  min-height: 44px;\n  width: 100%;\n  padding: 12px 16px;\n  background: var(--color-brand);\n  color: var(--color-on-brand);\n  border: none;\n  border-radius: var(--radius-control);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.16s ease, box-shadow 0.16s ease;\n  box-shadow: 0 1px 2px rgba(var(--color-text-rgb), 0.08);\n}\n\n.submit-btn:hover {\n  background: var(--color-brand-hover);\n  box-shadow: 0 3px 8px rgba(var(--color-brand-rgb), 0.16);\n}\n\n/* Leaders panel */\n.leaders-panel {\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n}\n\n/* Audit section */\n.audit-section {\n  margin-top: 28px;\n  background: transparent;\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n  border: 0;\n}\n\n.audit-section-title {\n  font-size: 1.45rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: var(--color-text);\n}\n\n.audit-section-description {\n  color: var(--color-text-muted);\n  margin-bottom: 25px;\n}\n\n.audit-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.audit-form-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.audit-form-grid > .form-group:nth-child(4) {\n  grid-column: 1 / -1;\n}\n\n.audit-full-list,\n.audit-city-journals {\n  margin-top: 30px;\n}\n\n.audit-subtitle {\n  font-size: 1.3rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n  color: var(--color-text);\n}\n\n.audit-table-wrapper {\n  overflow-x: auto;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-control);\n  box-shadow: none;\n}\n\n.audit-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.audit-table th,\n.audit-table td {\n  padding: 14px;\n  text-align: left;\n  border-bottom: 1px solid rgba(var(--color-border-rgb), 0.78);\n}\n\n.audit-table th {\n  background: var(--color-surface-muted);\n  font-weight: 600;\n}\n\n.audit-table tbody tr:nth-child(even) {\n  background: rgba(var(--color-surface-muted-rgb), 0.55);\n}\n\n.audit-empty {\n  padding: 20px;\n  border: 1px dashed rgba(var(--color-brand-rgb), 0.22);\n  border-radius: 10px;\n  color: var(--color-text-muted);\n}\n\n.audit-city-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n}\n\n.audit-city-card {\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-control);\n  padding: 16px;\n  background: var(--color-surface);\n  box-shadow: var(--shadow-panel);\n}\n\n.audit-city-card-title {\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.audit-city-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.audit-city-list-item {\n  border-left: 4px solid var(--color-brand);\n  padding-left: 10px;\n}\n\n.audit-city-list-count {\n  font-weight: 600;\n}\n\n.audit-city-list-date,\n.audit-city-list-stamp {\n  font-size: 0.9rem;\n  color: var(--color-text-muted);\n}\n\n.audit-city-empty {\n  color: var(--color-text-muted);\n}\n\n.audit-submit-btn {\n  min-height: 44px;\n  padding: 16px;\n  border: none;\n  border-radius: var(--radius-control);\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--color-on-brand);\n  cursor: pointer;\n  background: var(--color-brand);\n  transition: background-color 0.16s ease, box-shadow 0.16s ease;\n  box-shadow: 0 1px 2px rgba(var(--color-text-rgb), 0.08);\n}\n\n.audit-submit-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.audit-submit-btn:disabled:hover {\n  background: var(--color-brand);\n  box-shadow: 0 1px 2px rgba(var(--color-text-rgb), 0.08);\n}\n\n.audit-submit-btn:not(:disabled):hover {\n  background: var(--color-brand-hover);\n  box-shadow: 0 3px 8px rgba(var(--color-brand-rgb), 0.16);\n}\n\n.panel-title {\n  font-size: 1.3rem;\n  line-height: 1.3;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: var(--color-text);\n}\n\n/* Data table */\n.leaders-list {\n  overflow-x: auto;\n  background: var(--color-surface);\n  border-radius: var(--radius-control);\n  box-shadow: none;\n  border: 1px solid var(--color-border);\n}\n\n.data-table {\n  width: 100%;\n  min-width: 1120px;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.data-table th {\n  background: var(--color-surface-muted);\n  color: var(--color-text);\n  padding: 13px 12px;\n  text-align: left;\n  font-weight: 600;\n  border-bottom: 1px solid var(--color-border);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.data-table th.sortable-column {\n  padding: 0;\n}\n\n.table-sort-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  min-height: 44px;\n  padding: 12px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-weight: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.16s ease, color 0.16s ease;\n}\n\n.table-sort-button:hover {\n  background: var(--color-brand-soft);\n  color: var(--color-brand-hover);\n}\n\n.data-table td {\n  padding: 12px;\n  border-bottom: 1px solid var(--color-border);\n  transition: background-color 0.2s ease;\n}\n\n.data-table tbody tr:hover {\n  background: rgba(var(--color-surface-muted-rgb), 0.8);\n}\n\n.data-table tbody tr:nth-child(even) {\n  background: rgba(var(--color-surface-muted-rgb), 0.45);\n}\n\n.data-table tbody tr:nth-child(even):hover {\n  background: rgba(var(--color-surface-muted-rgb), 0.9);\n}\n\n/* Highlight cells above average */\n.highlight-above-average {\n  background: var(--color-brand-soft) !important;\n  font-weight: 600;\n  color: var(--color-brand-hover);\n}\n\n/* Action buttons in table */\n.data-table td:last-child {\n  text-align: center;\n  min-width: 100px;\n}\n\n.leaders-table th:nth-child(11),\n.leaders-table td:nth-child(11) {\n  width: 190px;\n  min-width: 190px;\n  max-width: 190px;\n}\n\n.leaders-table th:last-child,\n.leaders-table td:last-child {\n  width: 104px;\n  min-width: 104px;\n  max-width: 104px;\n  text-align: center;\n}\n\n.coffee-shops-table {\n  width: 100%;\n  min-width: 680px;\n  table-layout: fixed;\n}\n\n.coffee-shops-table th:last-child,\n.coffee-shops-table td:last-child {\n  width: 124px;\n  min-width: 124px;\n  max-width: 124px;\n  text-align: center;\n}\n\n.leaders-table .action-btn,\n.coffee-shops-table .action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 32px;\n  padding: 0;\n  margin: 0 2px;\n  line-height: 1;\n  vertical-align: middle;\n}\n\n.data-table .action-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: background-color 0.16s ease;\n  margin: 0 2px;\n}\n\n.data-table .edit-btn {\n  background: var(--color-brand);\n  color: var(--color-on-brand);\n}\n\n.data-table .edit-btn:hover {\n  background: var(--color-brand-hover);\n}\n\n.data-table .delete-btn {\n  background: var(--color-danger);\n  color: var(--color-on-brand);\n}\n\n.data-table .delete-btn:hover {\n  background: var(--color-danger-hover);\n}\n\n/* Leader/Coffee shop cards */\n.leader-card {\n  background: var(--color-surface);\n  border-radius: var(--radius-control);\n  padding: 20px;\n  transition: border-color 0.16s ease, box-shadow 0.16s ease;\n  position: relative;\n  border: 1px solid rgba(var(--color-border-rgb), 0.65);\n  border-left: 4px solid var(--color-brand);\n}\n\n.leader-card:hover {\n  box-shadow: var(--shadow-panel);\n  border-color: var(--color-brand);\n}\n\n.leader-name {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 10px;\n  color: var(--color-text);\n}\n\n.leader-info {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  font-size: 0.9rem;\n  color: var(--color-text);\n  opacity: 0.8;\n}\n\n.leader-info div {\n  display: flex;\n  align-items: center;\n}\n\n/* Action buttons */\n.leader-actions {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  display: flex;\n  gap: 5px;\n}\n\n.action-btn {\n  padding: 6px 10px;\n  border: none;\n  border-radius: 5px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.edit-btn {\n  background: var(--color-brand);\n  color: var(--color-on-brand);\n}\n\n.edit-btn:hover {\n  background: var(--color-brand-hover);\n}\n\n.delete-btn {\n  background: var(--color-danger);\n  color: var(--color-on-brand);\n}\n\n.delete-btn:hover {\n  background: var(--color-danger-hover);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .app {\n    padding: 18px 14px 36px;\n  }\n\n  .title {\n    font-size: 1.75rem;\n  }\n\n  .city-filter {\n    flex-direction: row;\n    align-items: stretch;\n    gap: 7px;\n  }\n\n  .city-btn {\n    flex: 1 1 auto;\n    min-height: 42px;\n    padding-inline: 12px;\n  }\n\n  .metrics-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 9px;\n  }\n\n  .metric-group--forecast {\n    grid-column: auto;\n  }\n\n  .metric-card {\n    padding: 14px;\n  }\n\n  .metric-group .metric-number {\n    font-size: 1.65rem;\n  }\n\n  .action-buttons {\n    flex-direction: row;\n    align-items: stretch;\n    gap: 8px;\n  }\n\n  .action-buttons > button {\n    flex: 1 1 160px;\n  }\n\n  .tab-buttons {\n    align-self: stretch;\n  }\n\n  .tab-buttons > .tab-btn {\n    flex: 1 1 140px;\n  }\n\n  .analytics-section {\n    padding: 18px 14px;\n  }\n\n  .audit-form-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .data-table {\n    font-size: 0.8rem;\n  }\n\n  .data-table th,\n  .data-table td {\n    padding: 8px 6px;\n  }\n\n  .data-table th {\n    font-size: 0.75rem;\n  }\n\n  .modal-content {\n    margin: 12px;\n    padding: 22px 18px;\n    width: calc(100% - 24px);\n    max-height: calc(100dvh - 24px);\n  }\n}\n\n@media (max-width: 420px) {\n  .app {\n    padding-inline: 12px;\n  }\n\n  .metrics-grid {\n    gap: 8px;\n  }\n\n  .metric-card {\n    padding: 12px;\n  }\n\n  .metric-group-items--four {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 14px;\n  }\n\n  .metric-group-items--four .metric-item:nth-child(3) {\n    border-left: 0;\n    padding-left: 0;\n  }\n\n  .metric-group-items--four .metric-item:nth-child(n + 3) {\n    border-top: 1px solid var(--color-border);\n    padding-top: 12px;\n  }\n\n  .metric-group .metric-number {\n    font-size: 1.35rem;\n  }\n\n  .metric-group .metric-label {\n    font-size: 0.76rem;\n  }\n\n  .audit-summary-content {\n    gap: 12px;\n  }\n\n  .audit-summary-entry {\n    padding: 12px;\n  }\n\n  .audit-form-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n/* ИПВ link styles */\n.pip-link {\n  color: var(--color-brand) !important;\n  text-decoration: underline;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.pip-link:hover {\n  color: var(--color-brand-hover) !important;\n  text-decoration: none;\n}\n\n/* Manual/Auto attrition risk styles */\n.manual-value {\n  color: var(--color-text) !important;\n  font-weight: bold;\n}\n\n.auto-value {\n  color: var(--color-text-muted) !important;\n  font-weight: normal;\n}\n\n.attrition-cell span:hover {\n  text-decoration: underline;\n}\n\n.data-table th:nth-child(7),\n.data-table td:nth-child(7),\n.data-table th:nth-child(8),\n.data-table td:nth-child(8),\n.data-table th:nth-child(9),\n.data-table td:nth-child(9),\n.data-table th:nth-child(10),\n.data-table td:nth-child(10) {\n  width: 60px;\n  min-width: 60px;\n  max-width: 90px;\n  text-align: center;\n  padding: 14px 6px;\n}\n\n.data-table th:nth-child(7),\n.data-table th:nth-child(8),\n.data-table th:nth-child(9),\n.data-table th:nth-child(10) {\n  font-size: 0.75rem;\n}\n\n/* Form section for risk */\n.form-section-title {\n  margin: 30px 0 15px 0;\n  padding-bottom: 10px;\n  border-bottom: 2px solid var(--color-brand);\n  color: var(--color-text);\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.form-hint {\n  display: block;\n  margin-top: 5px;\n  color: var(--color-text-muted);\n  font-size: 0.85rem;\n  line-height: 1.4;\n}\n\n.pip-risk-floor-hint {\n  margin: -6px 0 14px;\n}\n\n.risk-actions {\n  display: flex;\n  justify-content: flex-start;\n  margin: 2px 0 14px;\n}\n\n.pip-clear-btn {\n  background: var(--color-surface-muted);\n  border: 1px solid var(--color-border);\n  color: var(--color-text-muted);\n  padding: 12px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  min-height: 44px;\n}\n\n.pip-clear-btn:hover:not(:disabled) {\n  background: var(--color-border);\n  border-color: var(--color-border);\n  color: var(--color-text);\n}\n\n.pip-clear-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.risk-clear-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  width: auto;\n  max-width: 100%;\n  min-height: 40px;\n  background: var(--color-brand-soft);\n  border: 1px solid rgba(var(--color-brand-rgb), 0.22);\n  color: var(--color-brand-hover);\n  padding: 6px 14px;\n  border-radius: 999px;\n  cursor: pointer;\n  font: inherit;\n  font-size: 0.9rem;\n  font-weight: 600;\n  line-height: 1.3;\n  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;\n}\n\n.risk-clear-btn:hover:not(:disabled) {\n  background: var(--color-brand);\n  border-color: var(--color-brand);\n  color: var(--color-on-brand);\n  box-shadow: 0 2px 6px rgba(var(--color-brand-rgb), 0.18);\n}\n\n.risk-clear-icon {\n  display: inline-grid;\n  place-items: center;\n  flex: 0 0 26px;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: rgba(var(--color-brand-rgb), 0.12);\n  color: var(--color-brand);\n  font-size: 1.2rem;\n  line-height: 1;\n}\n\n.risk-clear-btn:hover:not(:disabled) .risk-clear-icon {\n  background: rgba(var(--color-text-rgb), 0.12);\n  color: var(--color-on-brand);\n}\n\n@media (max-width: 520px) {\n  .risk-clear-btn {\n    border-radius: var(--radius-control);\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
